import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/auth';

import MainLayout from '../components/Layout/MainLayout';

const RouteWrapper = () => {
    const { user } = useAuth();
    const location = useLocation();

    // Se não está logado, redireciona para o login
    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // Se está logado, permite que as rotas filhas (dentro do layout) sejam renderizadas
    return (
        <MainLayout>
            <Outlet />
        </MainLayout>
    );
};

export default RouteWrapper;